// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.far[data-v-5e2c7770],.fas[data-v-5e2c7770]{width:1em;text-align:center}`, "",{"version":3,"sources":["webpack://./ClientApp/components/kanban/modal/detailscontent/CardInfo.vue"],"names":[],"mappings":"AACA,4CAEE,SAAA,CACA,iBAAA","sourcesContent":["\r\n.far,\r\n.fas {\r\n  width: 1em;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
